/******************
* Overlay
*
* 
* Creates a simple HTML container element that overlays (and possibly dims) the whole viewport.
* Often used to show popup windows.
*
*******************/

if(typeof FN == 'undefined') FN = {};

FN.overlay = {
  config: {
    fadeDuration: 500
  },
  selectors: {
    baseElementClass: 'overlay__container',
    closeButtonClass: 'overlay__button--close',
    contentElementClass: 'overlay__content'
  },

  _fadeIn: function(element) {
    if (!element) return;
    element.style.display = '';
    element.classList.remove('hidden');
  },

  _fadeOut: function(element, callback) {
    if (!element) return;
    element.classList.add('hidden');
    setTimeout(function() {
      element.style.display = 'none';
      if (callback) callback();
    }, FN.overlay.config.fadeDuration);
  },

  init: function(options){
    var baseElement = document.querySelector(options.baseElement);
    if (!baseElement) return;

    // close button event handling
    baseElement.querySelectorAll('.' + FN.overlay.selectors.closeButtonClass).forEach(function(button) {
      button.addEventListener('click', FN.overlay.close);
    });

    // show
    FN.overlay.show(baseElement);
  },


  show: function(baseElement){
    if (!baseElement) return;
    baseElement.classList.add('visible');
    FN.overlay.showContent(0, baseElement);
  },


  showContent: function(contentIndex, baseElement){
    if(!baseElement) baseElement = document.querySelector('.' + FN.overlay.selectors.baseElementClass);
    if (!baseElement) return;

    baseElement.querySelectorAll('.' + FN.overlay.selectors.contentElementClass).forEach(function(element, index){
      if(index === contentIndex){
        FN.overlay._fadeIn(element);
      }else{
        FN.overlay._fadeOut(element);
      }
    });
  },


  close: function(event){
    var target = event && event.target ? event.target : null;
    var baseElement = target ? target.closest('.' + FN.overlay.selectors.baseElementClass) : null;
    if (!baseElement) return;

    var contentElements = baseElement.querySelectorAll('.' + FN.overlay.selectors.contentElementClass);
    var remaining = contentElements.length;

    if (remaining === 0) {
      baseElement.classList.remove('visible');
    } else {
      contentElements.forEach(function(element){
        FN.overlay._fadeOut(element, function() {
          remaining--;
          if (remaining === 0) {
            baseElement.classList.remove('visible');
          }
        });
      });
    }

    if (event) event.preventDefault();
  }
}



/***********
* Usage
*/
/*
var overlay = FN.overlay.init({
  baseElement: '.overlay-wrapper'
});
*/
